import React from 'react';
import SvgIcon from './SvgIcon';

const DoubleArrowLeft = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M21.41.5L8.835 11.626a.5.5 0 000 .748L21.41 23.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.743.5L2.168 11.626a.5.5 0 000 .748L14.743 23.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

DoubleArrowLeft.displayName = 'DoubleArrowLeftIcon';

export default DoubleArrowLeft;
